import comp from "./TimeSelectorV2";
export default comp;
